export default {
  bot: 'Bot',
  agent: 'Atendente',
  sequential_id: 'Ticket',
  customer_name: 'Cliente',
  queue_time: 'Tiempo en la Fila',
  first_response_time: 'Primera respuesta',
  attendance_time: 'Tiempo de atención',
};
